<template>
  <!-- 共用标题 dxm -->
  <div class="title_wrap">
    <!-- type 1 首页标题 2 二级页面标题 3 二级页面标题带图标 -->
    <div class="title" v-if="type == 1">
      {{ title }}
    </div>
    <div class="title_second" v-if="type == 2">
      {{ title }}
    </div>
    <div class="title_second flex flex_items_center" v-if="type == 3">
      <img :src="require('../assets/imgs/title_img.jpg')" alt="" /> {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    type: Number,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.title_wrap {
  .title {
    font-size: 38px;
    color: #001a33;
    line-height: 53px;
    font-weight: 500;
    position: relative;
  }
  .title_second {
    font-weight: 500;
    font-size: 30px;
    color: #001a33;
    line-height: 42px;
    img {
      width: 40px;
      margin-right: 10px;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .title_wrap {
    .title {
      font-size: 34px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .title_wrap {
    .title {
      font-size: 0.54rem;
      line-height: 0.77rem;
    }
    .title_second {
      font-size: 0.54rem;
      line-height: 0.77rem;
    }
  }
}
.main_partners {
  .title_wrap {
    .title {
      text-align: center;
      &::before {
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>